<template>
    <select @change="setPropagatedContent" @click.stop.prevent class="form-select form-select-sm w-auto">

        <!-- By default, the first content area is assigned to a page when it's selected. This avoids the need to
             validate the menus, which would add a lot of complexity to the propagation feature. -->
        <option selected disabled>Select&hellip;</option>

        <template v-if="pageSectionAreas?.length">
            <template v-for="(section, k) in pageSectionAreas">
                <optgroup :label="'Section ' + (k + 1)">
                    <option v-for="area in section.areas" :value="area.value"
                            :selected="area.value === selectedContentArea">{{ area.text }}
                    </option>
                </optgroup>
            </template>
        </template>

        <template v-else>
            <option v-for="contentArea in pageTemplatesContentAreas" :selected="contentArea === selectedContentArea">
                {{ contentArea }}
            </option>
        </template>
    </select>
</template>

<script>
export default {
    name: "SiteTreePageItemSelectMenu",
    props: {
        siteTreeId: String,
        pageId: Number
    },
    computed: {
        siteTree() {
            return this.$store.state[this.siteTreeId]
        },
        pageTemplatesContentAreas() {
            if (this.page) {
                return this.$store.state.pageTemplatesContentAreas.pageTemplatesContentAreas[this.page.templateId]
            }
        },
        selectedContentArea() {
            return this.siteTree.propagationData.find(o => o.pageId === this.pageId)?.contentArea
        },
        sections() {
            return this.$store.state.pageSections.items.filter(o => o.pageId === this.pageId)
        }
    },
    asyncComputed: {
        page() {
            return this.$store.dispatch('itemData/get', {
                tableName: 'pages',
                id: this.pageId
            })
        },
        async pageSectionAreas() {
            // Selecting the first option by default removes the need to validate the menus
            if (this.sections.length) {
                const contentArea = this.sections[0].areas[0].value
                this.$store.commit(this.siteTreeId + '/propagationData', {
                    pageId: this.pageId,
                    contentArea
                })
            }

            return this.sections
        }
    },
    created() {
        this.$store.dispatch('pageSections/init')
    },
    methods: {
        setPropagatedContent(e) {
            const contentArea = e.target.value

            this.$store.commit(this.siteTreeId + '/propagationData', {
                pageId: this.pageId,
                contentArea
            })
        }
    }
}
</script>

<style scoped>

</style>